export enum PersonScenarioReportFields {
  id = 'id',
  personId = 'personId',
  personCredentialId = 'personCredentialId',
  imageId = 'imageId',
  email = 'email',
  firstName = 'firstName',
  middleName = 'middleName',
  lastName = 'lastName',
  fullName = 'fullName',
  externalSystemId = 'externalSystemId',
  scenarioDefinitionId = 'scenarioDefinitionId',
  scenarioName = 'scenarioName',
  credentialApplicationNumber = 'credentialApplicationNumber',
  scenarioCompletion = 'scenarioCompletion',
  scenarioType = 'scenarioType',
  credentialApplicationStartDate = 'credentialApplicationStartDate',
  credentialApplicationEndDate = 'credentialApplicationEndDate',
  personScenarioUpdatedBy = 'personScenarioUpdatedBy',
  personScenarioUpdatedOn = 'personScenarioUpdatedOn',
  personScenarioCreatedBy = 'personScenarioCreatedBy',
  personScenarioCreatedOn = 'personScenarioCreatedOn',
  credentialDefinitionId = 'credentialDefinitionId',
  credentialName = 'credentialName',
  credentialApplicationType = 'credentialApplicationType',
  requirements = 'requirements',
  status = 'status',
}
